/* eslint-disable */

import Vue from 'vue'
import AXIOS from '@/integrations/axios'
import VueCookies from 'vue-cookies'
import {i18n} from '@/integrations/i18n'

Vue.use(VueCookies)

const state = {
  USER: {
    _token_access: Vue.$cookies.get('token_access') || null,
    _token_admin: Vue.$cookies.get('token_admin') || null,
    _profile_completed: Vue.$cookies.get('profile_completed') || null,
    _hide_ios_alert: !!Vue.$cookies.get('hide_ios_alert') || false,
    _hide_android_alert: !!Vue.$cookies.get('hide_android_alert') || false,
    _show_ios_alert: false,
    _push_public_key: Vue.$cookies.get('pushPublicKey') || null,
    _show_android_alert: false,
    _menu: JSON.parse(window.localStorage.getItem('app_menu')) || [],
    _is_networking_enabled: Vue.$cookies.get('is_networking_enabled') || false,
    _activity: {
      items: [],
      totalPages: 1,
      scrollTop: 0
    },
    _notifications: Vue.$cookies.get('notifications') || null,
    _id: Vue.$cookies.get('user_id') || null,
    _is_admin: false,
    _preferences_all: Vue.$cookies.get('preferences_all') || null,
    _achievements_all: Vue.$cookies.get('achievements_all') || null,
    _auth_email: Vue.$cookies.get('auth_email') || null,
    _registration_email: Vue.$cookies.get('registration_email') || null,
    _prompt: null,
    _return_url: Vue.$cookies.get('return_url') || null
  },
  SW: null,
  menu_loaded: false,
  activity_loaded: false,
  notifications_loaded: false,
  owner_email: Vue.$cookies.get('owner_email') || null,
  claims: Vue.$cookies.get('claims') || null,
  max_content_length: Vue.$cookies.get('max_content_length') || 0,
  current_module: null,
  NETWORKING: null
}

// getters
const getters = {
  userTokenAccess: state => state.USER._token_access,
  userTokenAdmin: state => state.USER._token_admin,
  SWLoaded: state => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (state.SW) {
          clearInterval(interval)
          resolve()
        }
      }, 333)
    })
  },
  SW: state => state.SW,
  userPushPublicKey: state => state.USER._push_public_key,
  userPreference: state => state.USER._preferences_all,
  userAchievementsAll: state => state.USER._achievements_all,
  userProfileCompleted: state => state.USER._profile_completed,
  userHideIosAlert: state => state.USER._hide_ios_alert,
  showIosAlert: state => state.USER._show_ios_alert,
  showAndroidAlert: state => state.USER._show_android_alert,
  userHideAndroidAlert: state => state.USER._hide_android_alert,
  userMenu: state => state.USER._menu,
  isNetworkingEnabled: state => state.USER._is_networking_enabled,
  userId: state => state.USER._id,
  userIsAdmin: state => state.USER._is_admin,
  userAuthEmail: state => state.USER._auth_email,
  userRegistrationEmail: state => state.USER._registration_email,
  userPrompt: state => state.USER._prompt,
  userLoggedIn: state => !!state.USER._token_access || !!state.USER._token_admin,
  userFirstModule: state => state.USER._menu[0],
  userReturnUrl: state => state.USER._return_url,
  userProfileModule: state => {
    let arr = JSON.parse(JSON.stringify(state.USER._menu))
    const [profile] = arr.splice(arr.indexOf(arr.find(el => el.type === 'profile')), 1)
    return profile
  },
  userNetworkingModule: state => {
    let arr = JSON.parse(JSON.stringify(state.USER._menu))
    const [profile] = arr.splice(arr.indexOf(arr.find(el => el.type === 'networking')), 1)
    return profile
  },
  userForumsModule: state => {
    let arr = JSON.parse(JSON.stringify(state.USER._menu))
    const [profile] = arr.splice(arr.indexOf(arr.find(el => el.type === 'forums')), 1)
    return profile
  },
  userChatsModule: state => {
    let arr = JSON.parse(JSON.stringify(state.USER._menu))
    const [profile] = arr.splice(arr.indexOf(arr.find(el => el.type === 'chats')), 1)
    return profile
  },
  menuLoaded: state => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (state.menu_loaded) {
          clearInterval(interval)
          resolve()
        }
        if (!state.USER._token_access && !state.USER._token_admin) resolve()
      }, 333)
    })
  },
  activityLoaded: state => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (state.activity_loaded) {
          clearInterval(interval)
          resolve()
        }
        if (!state.USER._token_access && !state.USER._token_admin) resolve()
      }, 333)
    })
  },
  notificationsLoaded: state => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (state.notifications_loaded) {
          clearInterval(interval)
          resolve()
        }
        if (!state.USER._token_access && !state.USER._token_admin) resolve()
      }, 333)
    })
  },
  userNotifications: state => state.USER._notifications,
  ownerEmail: state => state.owner_email,
  claims: state => state.claims,
  maxContentLength: state => state.max_content_length,
  userCurrentModule: state => state.current_module,
  userActivity: state => state.USER._activity,
  userNetworking: state => state.NETWORKING
}

// actions
const actions = {
  async getUserMenu({commit}) {
    if (state.USER._token_access || state.USER._token_admin) {
      try {
        const result = await AXIOS.get('/user/app-menu')
        if (result.data.is_profile_completed.length > 0) commit('setProfileCompletedState', 0)
        else commit('setProfileCompletedState', 1)
        commit('setAppMenu', result.data)
        commit('setUid', result.data.user_id)
        commit('setOwnerEmail', result.data.owner_email)
        commit('setAppClaims', result.data.claims)
        commit('setMaxContentLength', result.data.max_upload_size)
        commit('setAdminState', result.data.is_admin)
        commit('setPreferences', result.data.preferences_all)
        commit('setAchievements', result.data.achive_badges_all)
        VueCookies.set('locale', result.data.locale, '365d')
        i18n.locale = result.data.locale
        try {
          commit('setAppLocale', result.data.locale, { root: true })
        } catch (e) {
          // ignore if root mutation doesn't exist
        }

        // If i18n is attached to Vue prototype (e.g. this.$i18n), update that too
        if (Vue.prototype && Vue.prototype.$i18n) {
          Vue.prototype.$i18n.locale = result.data.locale
        }
      } catch (err) {
        commit('setMenuLoaded')
        console.log(err)
      }
    }
  },
  async subscribeToPushNotifications(ctx, {subscription, method}) {
    if (state.USER._token_access || state.USER._token_admin) {
      const key = subscription.getKey('p256dh')
      const token = subscription.getKey('auth')
      const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0]

      return new Promise((resolve, reject) => {
        if (method === 'POST') {
          AXIOS.post('/push-subscription', {
            endpoint: subscription.endpoint,
            public_key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
            auth_token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
            encoding: contentEncoding
          })
            .then(() => resolve())
            .catch(() => reject())
        } else if (method === 'PUT') {
          AXIOS.put('/push-subscription/0', {
            endpoint: subscription.endpoint,
            public_key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
            auth_token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
            encoding: contentEncoding,
            user_id: state.USER._id
          })
            .then(() => resolve())
            .catch(() => reject())
        } else if (method === 'DELETE') {
          AXIOS.delete('/push-subscription/0', {
            data: {
              endpoint: subscription.endpoint,
              public_key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
              auth_token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
              encoding: contentEncoding
            }
          })
            .then(() => resolve())
            .catch(() => reject())
        }
      })
    }
  },
  async getUserActivity({commit}) {
    if (state.USER._token_access || state.USER._token_admin) {
      AXIOS.get('/user/activity').then(result => {
        commit('setActivityItems', result.data)
        commit('setActivityPages', result.headers['x-pagination-page-count'])
      })
    }
  },
  async getUserNotifications({commit}) {
    if (state.USER._token_access || state.USER._token_admin) {
      AXIOS.get('/user/settings').then(res => {
        commit('setUserNotificationState', res.data.notification_mode)
      })
    }
  }
}

// mutations
const mutations = {
  setProfileCompletedState(state, data) {
    Vue.$cookies.set('profile_completed', data)
    state.USER._profile_completed = data
  },
  setPreferences(state, data) {
    Vue.$cookies.set('preferences_all', data)
    state.USER._preferences_all = data
  },
  setAchievements(state, data) {
    Vue.$cookies.set('achievements_all', data)
    state.USER._achievements_all = data
  },
  saveSW(state, data) {
    state.SW = data
  },
  setNetworkingState(state, data) {
    state.NETWORKING = data
  },
  setMenuLoaded(state) {
    state.menu_loaded = true
  },
  setAppMenu(state, data) {
    let menu = []
    let isNetworkingEnabled = false
    for (let i = 0; i < data.menu.length; i++) {
      menu.push({
        'app_module_id': data.menu[i].app_module_id,
        'name': data.menu[i].name,
        'position': data.menu[i].position,
        'bubble': [],
        'type': data.menu[i].type,
        'icon-name': data.menu[i].icon_name,
        'icon': data.menu[i].icon,
        'url': data.menu[i].url ? data.menu[i].url : null,
        'params': data.menu[i].params
      })
      if (data.menu[i].type === 'networking') isNetworkingEnabled = true
    }
    if (state.USER._hide_ios_alert || state.USER._hide_android_alert) {
      let type = ''
      if (state.USER._hide_ios_alert) type = 'installIos'
      else if (state.USER._hide_android_alert) type = 'installAndroid'
      menu.push({
        app_module_id: null,
        name: i18n.t('components.menu.installApp'),
        type: type,
        bubble: [],
        icon: `<svg id="icon" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none"></rect>
                    <polyline points="86 58 128 16 170 58" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                    <line x1="128" y1="128" x2="128" y2="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
                    <path d="M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
                </svg>`
      })
    }
    if ('setAppBadge' in navigator && data.app_badge_count > 0 && data.app_badge_count !== false)
      navigator.setAppBadge(data.app_badge_count)
    if ('clearAppBadge' in navigator && data.app_badge_count === false) navigator.clearAppBadge()

    window.localStorage.setItem('app_menu', JSON.stringify(menu))
    state.USER._menu = menu
    state.menu_loaded = true

    Vue.$cookies.set('pushPublicKey', data.push_public_key)
    state.USER._push_public_key = data.push_public_key

    Vue.$cookies.set('is_networking_enabled', isNetworkingEnabled)
    state.USER._is_networking_enabled = isNetworkingEnabled
  },
  handleUserBubble(state, data) {
    const menu_item = state.USER._menu.find(el => {
      return +el.app_module_id === +data.module.split('/')[1]
    })
    if (menu_item) {
      menu_item.bubble = data.items
    }
  },
  setBubblesToZero(state, data) {
    const menu_item = state.USER._menu.find(el => {
      return +el.app_module_id === +data.app_module_id
    })
    if (menu_item) {
      menu_item.bubble = []
    }
  },
  spliceBubbles(state, data) {
    const menu_item = state.USER._menu.find(el => {
      return +el.app_module_id === +data.app_module_id
    })
    if (menu_item) {
      const idx = menu_item.bubble.indexOf(data.item_id)
      if (idx < 0) return
      menu_item.bubble.splice(idx, 1)
    }
  },
  setActivityItems(state, data) {
    state.USER._activity.items = data
    state.activity_loaded = true
  },
  setActivityPages(state, data) {
    state.USER._activity.totalPages = data
  },
  saveActivityState(state, scroll) {
    state.USER._activity.scrollTop = scroll
  },
  setUserPrompt(state, data) {
    state.USER._prompt = data
  },
  setCurrentModule(state, data) {
    state.current_module = data
  },
  setUid(state, data) {
    Vue.$cookies.set('user_id', data)
    state.USER._id = data
  },
  setReturnUrl(state, data) {
    Vue.$cookies.set('return_url', data)
    state.USER._return_url = data
  },
  deleteReturnUrl(state) {
    Vue.$cookies.remove('return_url')
    state.USER._return_url = null
  },
  deleteUid(state) {
    Vue.$cookies.remove('user_id')
    state.USER._id = null
  },
  setOwnerEmail(state, data) {
    Vue.$cookies.set('owner_email', data)
    state.owner_email = data
  },
  setUserNotificationState(state, data) {
    Vue.$cookies.set('notifications', data, '365d')
    state.notifications_loaded = true
    state.USER._notifications = data
  },
  setAppClaims(state, data) {
    Vue.$cookies.set('claims', data)
    state.claims = data
  },
  setMaxContentLength(state, data) {
    Vue.$cookies.set('max_content_length', data)
    state.max_content_length = data
  },
  setAdminState(state, data) {
    state.USER._is_admin = data
  },
  setAccessToken(state, data) {
    Vue.$cookies.set('token_access', data, '365d')
    state.USER._token_access = data
  },
  deleteAccessToken(state) {
    Vue.$cookies.remove('token_access')
    state.USER._token_access = null
  },
  setAdminToken(state, data) {
    Vue.$cookies.set('token_admin', data)
    state.USER._token_admin = data
  },
  handleInstallPrompt(state, data) {
    if (data.platform === 'ios') state.USER._show_ios_alert = data.show
    else if (data.platform === 'android') state.USER._show_android_alert = data.show
    Vue.$cookies.set('install_declined', true)
  },
  deleteAdminToken(state) {
    Vue.$cookies.remove('token_admin')
    state.USER._token_admin = null
  },
  setAuthEmail(state, data) {
    Vue.$cookies.remove('registration_email')
    Vue.$cookies.set('auth_email', data)
    state.USER._auth_email = data
  },
  deleteAuthEmail(state) {
    Vue.$cookies.remove('auth_email')
    state.USER._auth_email = null
  },
  setRegistrationEmail(state, data) {
    Vue.$cookies.remove('auth_email')
    Vue.$cookies.set('registration_email', data)
    state.USER._registration_email = data
  },
  deleteRegistrationEmail(state) {
    Vue.$cookies.remove('registration_email')
    state.USER._registration_email = null
  },
  addNewUserActivity(state, data) {
    state.USER._activity.items.unshift(data)
  },
  setHideIosAlert(state) {
    Vue.$cookies.set('hide_ios_alert', true)
    state.USER._hide_ios_alert = true
    state.USER._menu.push({
      app_module_id: null,
      name: i18n.t('components.menu.installApp'),
      type: 'installIos',
      bubble: [],
      icon: `<svg id="icon" xmlns="http://www.w3.org/2000/svg" width="currentWidth" height="currentHeight" fill="currentColor" viewBox="0 0 256 256">
                  <rect width="256" height="256" fill="none"></rect>
                  <polyline points="86 58 128 16 170 58" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                  <line x1="128" y1="128" x2="128" y2="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
                  <path d="M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
              </svg>`
    })
  },
  setHideAndroidAlert(state) {
    Vue.$cookies.set('hide_android_alert', true)
    state.USER._hide_android_alert = true
    state.USER._menu.push({
      app_module_id: null,
      name: i18n.t('components.menu.installApp'),
      type: 'installAndroid',
      bubble: [],
      icon: `<svg id="icon" xmlns="http://www.w3.org/2000/svg" width="currentWidth" height="currentHeight" fill="currentColor" viewBox="0 0 256 256">
                  <rect width="256" height="256" fill="none"></rect>
                  <polyline points="86 58 128 16 170 58" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                  <line x1="128" y1="128" x2="128" y2="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
                  <path d="M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
              </svg>`
    })
  },
  deleteHideIosAlert(state) {
    Vue.$cookies.remove('hide_ios_alert')
    state.USER._hide_ios_alert = false
  },
  deleteHideAndroidAlert(state) {
    Vue.$cookies.remove('hide_android_alert')
    state.USER._hide_android_alert = false
  },
  userLogOut(state) {
    Vue.$cookies.remove('token_access')
    Vue.$cookies.remove('token_admin')
    Vue.$cookies.remove('user_id')
    Vue.$cookies.remove('install_declined')
    Vue.$cookies.remove('auth_email')
    Vue.$cookies.remove('registration_email')
    Vue.$cookies.remove('profile_completed')
    Vue.$cookies.remove('pushPromptDenied')
    state.USER._token_access = null
    state.USER._token_admin = null
    state.USER._profile_completed = null
    state.USER._hide_ios_alert = false
    state.USER._hide_android_alert = false
    state.USER._menu = []
    state.USER._id = null
    state.USER._is_admin = false
    state.USER._auth_email = null
    state.USER._registration_email = null
    state.USER._prompt = null
    if ('clearAppBadge' in navigator) navigator.clearAppBadge()
  }
}

export default {
  namespaced: true,
  namespace: 'user',
  state,
  getters,
  actions,
  mutations
}
